import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Welcome back! Please login to your account.", -1)
const _hoisted_2 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_3 = { class: "field custom-field custom-field_animated" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label" }, "Email address")
], -1)
const _hoisted_5 = { class: "field custom-field custom-field_animated" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label" }, "Password")
], -1)
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Forgot password ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.errors)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "field__input custom-field__input",
          placeholder: "e.g. your@email.com",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
        }, null, 512), [
          [_vModelText, _ctx.username]
        ]),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          class: "field__input custom-field__input",
          type: "password",
          placeholder: " ",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_ctx.onSubmit(_ctx.username, _ctx.password);}, ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.password]
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_router_link, {
        to: { name: 'forgot-password' },
        class: "button button--border"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        href: "#",
        class: "button button--orange",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {_ctx.onSubmit(_ctx.username, _ctx.password);}, ["prevent"]))
      }, "Login")
    ])
  ]))
}